export default {
	// careful, one only
	development: true,
	staging: false,
	production: false
}



// WEBPACK FOOTER //
// ./src/environment.js